import { Inertia } from '@inertiajs/inertia';
import { getCurrentInstance, h, nextTick, ref, Teleport } from 'vue';
import rescue from './helpers/rescue';
import get from 'lodash/get';

const items = ref({
  //
});

function remove(key) {
  rescue(() => {
    delete items.value[key];
  });
}

Inertia.on('invalid', event => {
  const response = event.detail.response;

  if (!get(response.headers, 'x-inertia-partial'))
    return;

  items.value[response.data.key] = response.data;

  return false;
});

Inertia.on('navigate', () => {
  items.value = {
    //
  }
});

export function usePartial() {
  const instance = getCurrentInstance();
  const key = get(instance, 'vnode.props.key');

  function unmount() {
    nextTick(() => remove(key));
  }

  return {
    remove,
    unmount,
    instance,
    items,
    key,
  }
}

const partials = {};

export function resolvePartial(name) {
  if (name in partials)
    return partials[name];

  // return partials[name] = defineAsyncComponent(() =>
  //   import(`./components/Partials/${name}.vue`)
  // );

  return partials[name] = require(`./components/Partials/${name}`).default;
}

export function renderPartial(component, props, to) {
  const Partial = resolvePartial(component);

  return to
    ? h(Teleport, { to }, h(Partial, props))
    : h(Partial, props)
}

export function renderPartials() {
  return Object.keys(items.value).map(key => {
    const { component, props, target } = items.value[key];

    return renderPartial(component, { ...props, key }, target);
  });
}
